import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

import * as Base from './base';

const AvailableCrownsCaption = styled(Base.AvailableCrownsCaption)`
  color: ${Styles.color.black};
`;

const BannerContainer = styled(Base.BannerContainer)`
  background-color: ${primitive.$white};
  color: ${Styles.color.black};
`;

const CurrentProgress = styled(Base.CurrentProgress)`
  height: 0.165rem;
  background-color: ${Styles.color.highlight};
`;

const DashboardButton = styled(Base.DashboardButton)`
  background-color: ${Styles.color.highlight};
  border-color: ${Styles.color.highlight};
  color: ${primitive.$white};
`;

const DetailsButton = styled(Base.DetailsButton)`
  background-color: ${primitive.$white};
  border-color: ${Styles.color.highlight};
  color: ${Styles.color.highlight};
`;

const PointsProgress = styled(Base.PointsProgress)`
  background-color: ${Styles.color.grey.eight};
`;

const TierDot = styled(Base.TierDot)<{ completed: boolean }>`
  background: ${p => (p.completed ? Styles.color.highlight : Styles.color.grey.eight)};
  &::before {
    inset-block-start: 0.75rem;
    color: ${p => (p.completed ? Styles.color.black : Styles.color.grey.eight)};
  }
`;

const UserCrownPointsContainer = styled(Base.UserCrownPointsContainer)`
  align-items: center;
  color: ${Styles.color.black};
`;

const StyledLoyaltyPointsIcon = styled(Base.StyledLoyaltyPointsIcon)`
  height: 2rem;
  width: 2rem;
  path {
    fill: ${p => p.theme.token('text-loyalty-highlight')};
  }
`;

const StyledLoyaltyRewardsLogo = styled(Base.StyledLoyaltyRewardsLogo)`
  margin-block-end: 0.5rem;
  path {
    fill: ${Styles.color.highlight};
  }
`;

export * from './base';
export {
  AvailableCrownsCaption,
  BannerContainer,
  CurrentProgress,
  DashboardButton,
  DetailsButton,
  PointsProgress,
  TierDot,
  UserCrownPointsContainer,
  StyledLoyaltyPointsIcon,
  StyledLoyaltyRewardsLogo,
};
